import React from "react";
import {
  Box,
  Typography,
  Grid2 as Grid,
  Card,
  IconButton,
} from "@mui/material";

import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import EditIcon from "@mui/icons-material/Edit";

const sections = [
  {
    title: "Subjective",
    body: "Patient reports elevated morning sugars and occasional missed insulin doses. Mild fatigue noted.",
  },
  {
    title: "Objective",
    body: "A1c 8.4%, eGFR 42, creatinine 1.58 mg/dL, uACR 186 mg/g. BP remains above goal.",
  },
  {
    title: "Assessment",
    body: "Type 2 diabetes with diabetic CKD stage 3b and albuminuria. Hypertension suboptimally controlled.",
  },
  {
    title: "Plan",
    body: "Review insulin adherence, continue renal protection, monitor BP, repeat renal labs, and close care gaps.",
  },
];

const EditBtn = () => (
  <IconButton
    size="small"
    sx={{
      border: "1px solid",
      borderColor: "grey.300",
      backgroundColor: "#fff",
      borderRadius: 2,
      p: 0.5,
      "&:hover": {
        backgroundColor: "grey.100",
      },
    }}
  >
    <EditIcon fontSize="small" sx={{ color: "grey.600" }} />
  </IconButton>
);

const SectionCard = ({ title, body }) => {
  return (
    <Card
      variant="outlined"
      sx={{
        borderRadius: 4,
        p: 2,
      }}
    >
      {/* Header */}
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        mb={1}
      >
        <Box display="flex" alignItems="center" gap={1}>
          <DescriptionOutlinedIcon sx={{ color: "#2aa198" }} />
          <Typography fontWeight={600} color="#2aa198">
            {title}
          </Typography>
        </Box>

        <EditBtn />
      </Box>

      {/* Body */}
      <Typography color="text.primary">{body}</Typography>
    </Card>
  );
};

const ClinicalNotesUI = () => {
  return (
    <Box p={2}>
      <Grid container spacing={2}>
        <Grid size={{ xs: 12 }}>
          <Box display="flex" flexDirection="column" gap={2}>
            {sections.map((section) => (
              <SectionCard
                key={section.title}
                title={section.title}
                body={section.body}
              />
            ))}
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ClinicalNotesUI;
